import restaurant from "./restaurant";
import escape_game from "./escape_game";

export default {
    restaurant,
    escape_game,
};
